import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { DewStorageService } from './dew-storage.service';

/**
 * Impedisce l'accesso alle route della shell se non si è autenticati
 */
@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private storageService: DewStorageService, private router: Router) {}

  canActivate(): Observable<boolean> {
    if (!this.storageService.get(ConfigSession.token)) {
      this.router.navigate(['/auth/login']);
      return of(false);
    }

    return of(true);
  }
}
